
export const normalizeKeys = (data, type) => {
    data.map(d => {
        d.id = d[`${type}_id`];
        d.displayName = d[`${type}_display`];
    });
    return data;

};
